import jquery from 'jquery';
import * as page from '../pwa/page';


import * as Spinner from './common/spinner';
import EplAd from './common/EplAd';

window.spinner = Spinner;

window.jQuery = jquery;
window.$ = jquery;

//window.eplArgs = window.eplArgs || {};
//window.eplArgs.callback = (arg) => {
//    if (arg.k === "megaLateral") {
//        const div = document.getElementById('eplAdDivmegaLateral');
//        if (div.childNodes.length) {
//            document.body.classList.remove('con-mega');
//            document.body.classList.add('con-mega');    
//        }
//    }
//}

export function start() {
    return new Promise((resolve, reject) => {
        jquery(function() {
            if (window.banner && window.banner.sites) {
                let ad = new EplAd(window.banner.sites, window.keywords);
                ad.initSpaces();
            }
            if (!window.render) {
                resolve();
            } else {
                Spinner.show();
                page.loadData(window.location.href)
                    .then(rs => {
                        Spinner.hide();
                        resolve(rs);
                    })
                    .catch(err => {
                        Spinner.hide();
                        reject(err);
                    });
            }
        });
    });
}



// WEBPACK FOOTER //
// ./Statics/scripts/app.js